'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialResponder = undefined;

var _reselect = require('reselect');

var _getAssignedResponderInWidget = require('./getAssignedResponderInWidget');

var _getPotentialResponders = require('./getPotentialResponders');

var _getWidgetBotResponder = require('../../selectors/widgetDataSelectors/getWidgetBotResponder');

var getInitialResponder = exports.getInitialResponder = (0, _reselect.createSelector)([_getAssignedResponderInWidget.getAssignedResponderInWidget, _getPotentialResponders.getPotentialResponders, _getWidgetBotResponder.getWidgetBotResponder], function (responder, responders, botResponder) {
  if (botResponder) {
    return botResponder;
  }

  return responder || responders.get(0);
});


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getInitialResponder.js
// module id = 283
// module chunks = 2 3